import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { PlanInterval } from '../../../../models';

const useStyles = makeStyles(theme => ({
  billingCycleToggle: {
    display: 'flex',
    alignItems: 'center',
    background: 'transparent',
    backgroundColor: '#6e6e731a',
    border: '1px solid #d5d8dd',
    borderRadius: 8,
  },
  toggleButton: {
    padding: theme.spacing(1, 1.5),
    fontWeight: 600,
    fontSize: 13,
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  toggleButtonActive: {
    border: '1px solid #d5d8dd',
    borderRadius: 8,
    backgroundColor: '#ffffff',
    color: '#22283c',
    boxShadow: '0 0 0 2px rgba(91,95,199,0.09), 0 2px 20px rgba(91,95,199,0.10)',
  },
  toggleButtonInactive: {
    color: '#6E6E73',
  },
  saveBadge: {
    backgroundColor: '#5B5FC7',
    color: '#ffffff',
    borderRadius: 8,
    padding: theme.spacing(0.75, 1),
    fontSize: 11,
    fontWeight: 700,
    marginLeft: theme.spacing(0.75),
  },
}));

export const BillingToggle = (
  { isAnnual, setBillingInterval, toggelDisabled }: {
    isAnnual: boolean,
    setBillingInterval: (interval: PlanInterval) => void,
    toggelDisabled?: boolean,
  },
) => {
  const classes = useStyles();

  const handleChangeBillingInterval = (interval: PlanInterval) => {
    if (!toggelDisabled) {
      setBillingInterval(interval);
    }
  };

  return (
    <Box
      id="billing-cycle-toggle"
      key="billing-cycle-toggle"
      className={classes.billingCycleToggle}
    >
      <Box
        component="span"
        className={`${classes.toggleButton} ${!isAnnual ? classes.toggleButtonActive : classes.toggleButtonInactive}`}
        onClick={() => handleChangeBillingInterval(PlanInterval.MONTH)}
        role="button"
        tabIndex={0}
      >
        <FormattedMessage id="page.plan.v2.billing.monthly" />
      </Box>
      <Box
        id="billing-cycle-toggle-annual"
        component="span"
        className={`${classes.toggleButton} ${isAnnual ? classes.toggleButtonActive : classes.toggleButtonInactive}`}
        onClick={() => handleChangeBillingInterval(PlanInterval.YEAR)}
        role="button"
        tabIndex={0}
      >
        <FormattedMessage id="page.plan.v2.billing.annual" />
        <Box component="span" className={classes.saveBadge}>
          <FormattedMessage id="page.plan.v2.billing.save" />
        </Box>
      </Box>
    </Box>
  );
};
